export default {
  setUserCatalogs(state, payload) {
    if ('catalogs' in payload) {
      state.lastUpdate = '';
      state.userCatalogs = payload;
    }
  },
  setToken(state, payload) {
    state.token = payload;
  },
  setInfo(state, payload) {
    state.decodedToken = payload;
  },
  removeAuthData(state) {
    state.token = null;
    state.decodedToken = null;
  },
};
